import { t } from 'ember-intl';
import { divide } from 'tio-ui/math';
import safeFormatDate from 'tio-common/helpers/safe-format-date';
import safeFormatNumber from 'tio-common/helpers/safe-format-number';
import Table from 'tio-ui/components/table';
import type { PastContributionPayment } from 'tio-employee/services/employee';
import type { TOC } from '@ember/component/template-only';

export interface S {
  Args: {
    contributionPayments: PastContributionPayment[];
  };
}

const ContributionsAccountingPaymentsTable: TOC<S> = <template>
  <div class="flex flex-col gap-y-2">
    <div class="flex flex-row">
      <h3 class="font-medium self-center">{{t "slr.table.header"}}</h3>
    </div>
    {{#if @contributionPayments.length}}
      <Table @isLoading={{false}}>
        <:thead as |options|>
          <options.tr>
            <options.th>{{t "slr.table.benefit_cycle"}}</options.th>
            <options.th>{{t "slr.table.paid"}}</options.th>
            <options.th>{{t "slr.table.account"}}</options.th>
            <options.th>{{t "slr.total"}}</options.th>
          </options.tr>
        </:thead>
        <:tbody as |options|>
          {{#each @contributionPayments as |payment|}}
            <options.tr>
              <options.td>{{safeFormatDate
                  payment.line_item_period
                  month="short"
                  year="numeric"
                }}</options.td>
              <options.td>{{if
                  payment.transaction_date
                  (safeFormatDate
                    payment.transaction_date month="numeric" day="2-digit" year="numeric"
                  )
                  (t "slr.in_progress")
                }}</options.td>
              <options.td>{{payment.servicer}}</options.td>
              <options.td>{{safeFormatNumber
                  (divide payment.amount 100)
                  style="currency"
                  currency="USD"
                }}</options.td>
            </options.tr>
          {{/each}}
        </:tbody>
      </Table>
    {{else}}
      <p>{{t "slr.table.no_data"}}</p>
    {{/if}}
  </div>
</template>;

export default ContributionsAccountingPaymentsTable;
